import React from "react";
import PropTypes from "prop-types";

import { Checkbox } from "antd";

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const defaultProps = {
  value: null,
};

function CheckboxInput({ children, ...props }) {
  return <Checkbox {...props}>{children}</Checkbox>;
}

CheckboxInput.propTypes = propTypes;
CheckboxInput.defaultProps = defaultProps;

export default CheckboxInput;
